import ModelFactory from 'business/models/ModelFactory';
import BaseService from './BaseService';
import {
  DatabaseSizeAlertDTO,
  StorageInfoClient,
  StorageInfoTaskDTO,
} from 'business/models/Models';

export default class StorageInfoService extends BaseService {
  async getStorageInfo(request: StorageInfoTaskDTO): Promise<boolean> {
    const storageInfoClient: StorageInfoClient = ModelFactory(
      StorageInfoClient,
      false,
      true,
    );
    const result = await storageInfoClient.getStorageInfo(request);
    return result;
  }

  async getDatabaseSize(): Promise<string> {
    const storageInfoClient: StorageInfoClient = ModelFactory(
      StorageInfoClient,
      false,
      true,
    );
    const result = await storageInfoClient.getDatabaseSize();
    return result.totalDbSize;
  }

  async checkDatabaseSizeLimit(): Promise<DatabaseSizeAlertDTO> {
    const storageInfoClient: StorageInfoClient = ModelFactory(
      StorageInfoClient,
      false,
      true,
    );
    const result = await storageInfoClient.checkDatabaseSizeLimit();
    return result;
  }

  async stopStorageInfoTask(id: string): Promise<boolean> {
    const storageInfoClient: StorageInfoClient = ModelFactory(
      StorageInfoClient,
      false,
      true,
    );
    const result = await storageInfoClient.stopStorageInfoTask(id);
    return result;
  }
}
